import React from 'react'
import "./buttonui.css";

export default function ButtonUI(props) {
  return (
    <button className={props.lightMode + ' btn'}><span className="padding-sm">{props.text}</span></button>
  )
}